// // // src/components/School/NewsEvents.jsx

// // import React from "react";

// // const NewsEvents = () => (
// //   <section className="py-10 bg-gray-50 border-t">
// //     <div className="max-w-6xl mx-auto px-4">
// //       <h2 className="text-2xl font-bold text-indigo-700 mb-4">School News & Events</h2>
// //       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
// //         <div className="bg-white p-4 rounded shadow hover:shadow-md">
// //           <h3 className="font-semibold">Science Fair 2025</h3>
// //           <p className="text-sm text-gray-600">Students won 1st prize at district level 🎖️</p>
// //         </div>
// //         <div className="bg-white p-4 rounded shadow hover:shadow-md">
// //           <h3 className="font-semibold">Sports Meet</h3>
// //           <p className="text-sm text-gray-600">Annual inter-school games held successfully</p>
// //         </div>
// //         <div className="bg-white p-4 rounded shadow hover:shadow-md">
// //           <h3 className="font-semibold">New Library Wing</h3>
// //           <p className="text-sm text-gray-600">Inaugurated by DM last week 📚</p>
// //         </div>
// //       </div>
// //     </div>
// //   </section>
// // );

// // export default NewsEvents;



// // src/components/School/NewsEvents.jsx

// import React, { useEffect, useRef } from "react";
// import { SparklesIcon, TrophyIcon, BuildingLibraryIcon } from "@heroicons/react/24/solid";

// const events = [
//   {
//     title: "Science Fair 2025",
//     description: "Students won 1st prize at district level",
//     icon: <TrophyIcon className="h-6 w-6 text-yellow-500" />,
//   },
//   {
//     title: "Sports Meet",
//     description: "Annual inter-school games held successfully",
//     icon: <SparklesIcon className="h-6 w-6 text-indigo-500" />,
//   },
//   {
//     title: "New Library Wing",
//     description: "Inaugurated by DM last week",
//     icon: <BuildingLibraryIcon className="h-6 w-6 text-green-500" />,
//   },
//   {
//     title: "Cultural Fest 2025",
//     description: "A week full of colors, music & tradition",
//     icon: <SparklesIcon className="h-6 w-6 text-pink-500" />,
//   },
//   {
//     title: "Math Olympiad",
//     description: "10 students selected for state-level competition",
//     icon: <TrophyIcon className="h-6 w-6 text-blue-500" />,
//   },
// ];

// const NewsEvents = () => {
//   const scrollRef = useRef(null);

//   useEffect(() => {
//     const scrollContainer = scrollRef.current;

//     let scrollAmount = 0;

//     const scroll = () => {
//       if (!scrollContainer) return;

//       scrollAmount += 1;
//       scrollContainer.scrollLeft = scrollAmount;

//       // Reset scroll when at end
//       if (
//         scrollAmount >=
//         scrollContainer.scrollWidth - scrollContainer.clientWidth
//       ) {
//         scrollAmount = 0;
//       }
//     };

//     const interval = setInterval(scroll, 30); // Controls speed

//     return () => clearInterval(interval); // Cleanup
//   }, []);

//   return (
//     <section className="py-10 bg-white border-t">
//       <div className="max-w-6xl mx-auto px-4">
//         <h2 className="text-3xl font-bold text-indigo-700 mb-6">
//           🗞️ School News & Events
//         </h2>

//         <div
//           ref={scrollRef}
//           className="flex overflow-x-auto space-x-4 scrollbar-hide py-2"
//         >
//           {events.map((event, index) => (
//             <div
//               key={index}
//               className="flex-shrink-0 w-72 bg-gray-50 hover:bg-white border rounded-lg shadow-sm hover:shadow-md transition duration-300 p-4"
//             >
//               <div className="flex items-center gap-2 mb-2">
//                 {event.icon}
//                 <h3 className="font-semibold text-lg text-gray-800">{event.title}</h3>
//               </div>
//               <p className="text-sm text-gray-600">{event.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default NewsEvents;



// src/components/School/NewsEvents.jsx

import React, { useEffect, useRef, useState } from "react";
import {
  SparklesIcon,
  TrophyIcon,
  BuildingLibraryIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";

const events = [
  {
    title: "Science Fair 2025",
    description: "Students won 1st prize at district level",
    icon: <TrophyIcon className="h-6 w-6 text-yellow-500" />,
  },
  {
    title: "Sports Meet",
    description: "Annual inter-school games held successfully",
    icon: <SparklesIcon className="h-6 w-6 text-indigo-500" />,
  },
  {
    title: "New Library Wing",
    description: "Inaugurated by DM last week",
    icon: <BuildingLibraryIcon className="h-6 w-6 text-green-500" />,
  },
  {
    title: "Cultural Fest 2025",
    description: "A week full of colors, music & tradition",
    icon: <SparklesIcon className="h-6 w-6 text-pink-500" />,
  },
  {
    title: "Math Olympiad",
    description: "10 students selected for state-level competition",
    icon: <TrophyIcon className="h-6 w-6 text-blue-500" />,
  },
];

const NewsEvents = () => {
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const scrollByAmount = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const startAutoScroll = () => {
      intervalRef.current = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollBy({ left: 1, behavior: "smooth" });
          // Reset if scrolled to end
          if (
            scrollContainer.scrollLeft >=
            scrollContainer.scrollWidth - scrollContainer.clientWidth - 1
          ) {
            scrollContainer.scrollLeft = 0;
          }
        }
      }, 30);
    };

    startAutoScroll();

    return () => clearInterval(intervalRef.current);
  }, [isHovered]);

  return (
    <section className="py-10 bg-white border-t">
      <div className="max-w-6xl mx-auto px-4 relative">
        <h2 className="text-3xl font-bold text-indigo-700 mb-6">
          🗞️ School News & Events
        </h2>

        {/* Arrows */}
        <button
          onClick={() => scrollByAmount(-300)}
          className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white shadow-md rounded-full p-2 hover:bg-indigo-100 z-10"
        >
          <ChevronLeftIcon className="h-6 w-6 text-indigo-700" />
        </button>

        <button
          onClick={() => scrollByAmount(300)}
          className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white shadow-md rounded-full p-2 hover:bg-indigo-100 z-10"
        >
          <ChevronRightIcon className="h-6 w-6 text-indigo-700" />
        </button>

        {/* Scrollable container */}
        <div
          ref={scrollRef}
          className="flex overflow-x-auto space-x-4 scrollbar-hide py-2 px-1 transition-all duration-300"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {events.map((event, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-72 snap-start bg-gray-50 hover:bg-white border rounded-lg shadow-sm hover:shadow-md transition duration-300 p-4"
            >
              <div className="flex items-center gap-2 mb-2">
                {event.icon}
                <h3 className="font-semibold text-lg text-gray-800">
                  {event.title}
                </h3>
              </div>
              <p className="text-sm text-gray-600">{event.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsEvents;
